import baseConfigs from './base';

export default {
  ...baseConfigs,
  apiUrl: 'https://api.auto-design.io',
};
